import postWithToken from './base/post-with-token'

const addSettingReceiveMail = (type, emailValue) => postWithToken(`/list-receive-email-alert/update?type=${type}`)(emailValue)

export default addSettingReceiveMail